import { FallbackProvider } from "@ethersproject/providers";
import { pipe } from "fp-ts/lib/function";
import * as TaskEither from "fp-ts/TaskEither";
import { BlockNumberError } from "./types";
import { ProdProtocolKey, ProtocolInstance } from "@silo/types";
import { graphProtocolInstance } from "./graph-protocol-instance";

const STALE_DATA_BLOCK_THRESHOLD: Record<ProdProtocolKey, number> = {
  mainnetLegacy: 20,
  mainnetLlama: 20,
  mainnetGrand: 20,
  arbitrum: 700,
  optimism: 700,
  base: 700,
  lrtbase: 700,
};

export const blockNumberForGraph = (
  provider: FallbackProvider,
  protocolInstance: ProtocolInstance
) => {
  return pipe(
    graphProtocolInstance(protocolInstance),
    TaskEither.fromEither,
    TaskEither.chainW((_protocolInstance) =>
      TaskEither.tryCatch(
        async () => {
          const currentBlockNumber = await provider.getBlockNumber();

          return (
            currentBlockNumber - STALE_DATA_BLOCK_THRESHOLD[_protocolInstance]
          );
        },
        (error): BlockNumberError => ({
          _tag: "BlockNumberError",
          error,
          protocolInstance: _protocolInstance,
        })
      )
    )
  );
};
